import React from 'react';
import { Provider } from 'react-redux';
import {  BrowserRouter as Router } from 'react-router-dom';

import { AppRouter } from './routers/AppRouter';
import store  from './store';

export const CustomerApp = () => {
    return (
        <Provider store={ store }>
            <Router basename="/Clientes">
                <AppRouter />
            </Router>
        </Provider>
    )
}
